const initializeQuoteForm = () => {
  const formContents = document.querySelectorAll(".custom__quote-tab");
  const formButtons = document.querySelectorAll(".custom__quote-button");
  const nextButton = document.querySelector(".custom__quote-form-next-button[type='button']");
  const formSubmitButton = document.querySelector(".custom__quote-form-next-button[type='submit']");
  const bar = document.querySelector(".custom__quote-button-bar");
  let currentActiveIndex = 0;

  if (!formContents.length || !formButtons.length) return;

  const updateTab = (index) => {
    formContents.forEach((content) => content.classList.add("custom__quote-hide"));
    formButtons.forEach((button) => button.classList.remove("active"));

    formContents[index].classList.remove("custom__quote-hide");
    formButtons[index].classList.add("active");

    currentActiveIndex = index;

    const w = formButtons[0].offsetWidth;
    bar.style.transform = `translateX(${currentActiveIndex * w}px)`;

    if (index === formContents.length - 1) {
      nextButton.classList.add("custom__quote-form-hide");
      formSubmitButton.classList.remove("custom__quote-form-hide");
    } else {
      nextButton.classList.remove("custom__quote-form-hide");
      formSubmitButton.classList.add("custom__quote-form-hide");
    }

    nextButton.setAttribute("tab-index", index + 1);
  };

  nextButton?.addEventListener("click", () => {
    const currentIndex = Number(nextButton.getAttribute("tab-index")) || 1;
    if (currentIndex < formContents.length) {
      updateTab(currentIndex);
    }
  });

  formSubmitButton?.addEventListener("click", () => {
    const customBagSection = document.querySelector(".custom-bag");
    if (!customBagSection) return;

    window.scroll({
      top: customBagSection.getBoundingClientRect().top + window.scrollY - document.querySelector(".header").offsetHeight,
      behavior: "smooth",
    });
  });

  formButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      updateTab(index);
    });

    button.addEventListener("mouseover", () => {
      const w = formButtons[0].offsetWidth;
      bar.style.transform = `translateX(${index * w}px)`;
    });

    button.addEventListener("mouseout", () => {
      const w = formButtons[0].offsetWidth;
      bar.style.transform = `translateX(${currentActiveIndex * w}px)`;
    });
  });

  updateTab(0);
};

// Initialize on page load
initializeQuoteForm();

// Reinitialize when the Shopify customizer triggers a change
document.addEventListener("shopify:section:load", initializeQuoteForm);
document.addEventListener("shopify:section:reorder", initializeQuoteForm);
document.addEventListener("shopify:section:select", initializeQuoteForm);
document.addEventListener("shopify:section:deselect", initializeQuoteForm);
document.addEventListener("shopify:section:unload", initializeQuoteForm);
